import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { History } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import EmptyState from "@/components/EmptyState";
import { Badge } from "@/components/ui/badge";

const ACTION_TONES = {
    create: "bg-secondary/10 text-secondary-dark",
    update: "bg-ocean-50 text-ocean-700",
    delete: "bg-coral/10 text-coral-dark",
    send: "bg-emerald-50 text-emerald-700",
    payment: "bg-emerald-50 text-emerald-700",
    pay: "bg-emerald-50 text-emerald-700",
    invite: "bg-amber-50 text-amber-700",
    remove: "bg-coral/10 text-coral-dark",
    change_plan: "bg-coral/10 text-coral-dark",
    reconcile: "bg-secondary/10 text-secondary-dark",
};

export default function AuditLog() {
    const { currentOrg } = useAuth();
    const [items, setItems] = useState([]);
    useEffect(() => {
        if (!currentOrg) return;
        api.get("/audit").then(({ data }) => setItems(data.items || []));
    }, [currentOrg]);

    return (
        <div>
            <PageHeader subtitle="Workspace" title="Audit log" />
            {items.length === 0 ? (
                <EmptyState icon={History} title="No activity yet" description="Every important change will show up here." />
            ) : (
                <div className="rounded-3xl bg-white border border-sand-200 shadow-card divide-y divide-sand-200">
                    {items.map((e) => (
                        <div key={e.id} className="flex items-start gap-4 p-5" data-testid={`audit-${e.id}`}>
                            <div className="h-9 w-9 rounded-xl bg-sand-100 text-ocean-700 grid place-items-center">
                                <History className="h-4 w-4" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 text-sm">
                                    <span className="font-medium text-ocean-700">{e.actor_email}</span>
                                    <Badge className={`border-0 ${ACTION_TONES[e.action] || "bg-sand-200 text-ocean-700"}`}>{e.action}</Badge>
                                    <span className="text-muted-foreground">{e.entity}</span>
                                </div>
                                <div className="text-xs text-muted-foreground mt-1">{fmtDate(e.created_at)}</div>
                                {Object.keys(e.meta || {}).length > 0 && (
                                    <pre className="mt-2 text-[11px] text-muted-foreground bg-sand-50 rounded-lg p-2 font-mono overflow-x-auto">{JSON.stringify(e.meta, null, 2)}</pre>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
